import LoginForm from '../components/LoginForm/LoginForm'

type LoginProps = {}

const Login: React.FC<LoginProps> = () => {
  return <LoginForm></LoginForm>
}

export default Login
